import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coupon-panel',
  templateUrl: './coupon-panel.component.html',
  styleUrls: ['./coupon-panel.component.scss'],
})
export class CouponPanelComponent implements OnInit {
  constructor() {}

  windowCouponAmount: string;
  windowCouponLabel: string;
  couponTipPopupStatus: boolean = false;

  ngOnInit(): void {
    this.windowCouponAmount = window['wf_sso_coupon_amount'];
    this.windowCouponLabel = window['wf_sso_coupon_label'];
  }

  showCouponTip() {
    this.couponTipPopupStatus = true;
  }
}
